import '@/scss/pages/processing/processing.scss';
import {processingPage} from "@/js/pages/processing/components/processingPage";

processingPage();